import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../shared/Services/authentication.service";
import { ExactLogService } from "../back-office/Services/exact-log.service";
import { CookieManagerService } from "../shared/Services/cookie.service";

export const isAccessBackOfficeResolver = () => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);
  const exactLogService = inject(ExactLogService);
  const cookieManager = inject(CookieManagerService);

  if (!auth.isBackOffice()) {
    cookieManager.deleteCookie('token');
    cookieManager.deleteAllCookies();
    router.navigateByUrl('/login');
  }

  exactLogService.getCrmUpdateNotificationsCount();
  return true;
};

